import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class TicketsCategories {
    getCategoryList() {
        return axios
        .get(`${config["apiUrl"]}helpdesk/tickets/categories`, {
            headers: authHeader(),
        })
        .then((response) => {
            if (response.status == 200) {
            return response.data;
            }
            return null;
        })
        .catch((error) => {
            if (error.response.status == 401) {
            AuthService.logout();
            window.location = "/login";
            }
            console.log("ERROR:: ", error.response.data);
            return null;
        });
    }
    createTicketCategory(payload) {
        return axios.post(`${config["apiUrl"]}helpdesk/tickets/categories/store`, payload, {
            headers: authHeader(),
        }).then((response) => {
            if (response.status == 200) {
                return response.data;
            }
            return null;
        })
        .catch((error) => {
            if (error.response.status == 401) {
                AuthService.logout();
                window.location = "/login";
            }
            console.log("ERROR:: ", error.response.data);
            return null;
        });
    }
    updateTicketCategory(id, payload) {
        return axios
        .patch(`${config["apiUrl"]}helpdesk/tickets/categories/update/${id}`, payload, {
            headers: authHeader(),
        })
        .then((response) => {
            if (response.status == 200) {
                return response.data;
            }

            return null;
        })
        .catch((error) => {
            if (error.response.status == 401) {
                AuthService.logout();
                window.location = "/login";
            }
            console.log("ERROR:: ", error.response.data);

            return null;
        });
    }
    deleteTicketCategory(id) {
        return axios
        .delete(`${config["apiUrl"]}helpdesk/tickets/delete/${id}`, {
            headers: authHeader(),
          })
        .then((response) => {
            if (response.status == 200) {
              return response.data;
            }
            return null;
          })
        .catch((error) => {
            if (error.response.status == 401) {
              AuthService.logout();
              window.location = "/login";
            }
            console.log("ERROR:: ", error.response.data);
            return null;
        });
    }
}

export default new TicketsCategories();